import * as React from "react";
import type { AppTabListOverflowMenuItemProps } from "./AppTabListOverflowMenu.types";
import { renderAppTabListOverflowMenuItem } from "./renderAppTabListOverflowMenuItem";
import { useAppTabListOverflowMenuItem } from "./useAppTabListOverflowMenuItem";
import { useAppTabListOverflowMenuItemStyles } from "./useAppTabListOverflowMenuStyles.styles";

/**
 * A menu for selecting tabs that have overflowed and are in a menu
 */
export const AppTabListOverflowMenuItem = React.memo(
  React.forwardRef<HTMLDivElement, AppTabListOverflowMenuItemProps>(
    (props, ref) => {
      const state = useAppTabListOverflowMenuItem(props, ref);
      useAppTabListOverflowMenuItemStyles(state);
      return renderAppTabListOverflowMenuItem(state);
    }
  )
);

AppTabListOverflowMenuItem.displayName = "next/AppTabListOverflowMenuItem";
